export default __webpack_public_path__ + "static/envelope-enable-workflows-7b0099d7ddd2919be53704050c62d5b6.png";